import styled from 'styled-components';

/** One way to pay: a white row with its title, a line on it and a radio. */
export const ModeOption = styled.div<{
  $checked: boolean;
  $disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px 14px 20px;
  border-radius: 20px;
  background: ${({ theme }) => theme.white};
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  border: 1px solid
    ${({ $checked, theme }) => ($checked ? theme.primary : 'transparent')};
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  transition: ${({ theme }) => theme.transitions.ease200ms};
  text-align: left;
`;
